module.exports = __webpack_public_path__ + "static/AngelaHe14-648f5f8ee6ba9ad01c2154d54c206b39.webp";